class ZendeskLauncher extends HTMLElement {
    constructor() {
        super();

        this.launcherButton = "";

        this.widgetOpen = false;
        this.hideOnLanding = false;
    }

    connectedCallback() {
        this.launcherButton = this.querySelector(".zendesk__launcher-btn");
        this.notificationIcon = this.querySelector(
            ".zendesk__launcher-notification",
        );

        this.hideOnLanding = this.dataset.hideOnLanding === "true";

        this.initialise();
    }

    toggleWidget() {
        if (this.widgetOpen) {
            zE("messenger", "close");
        } else {
            zE("messenger", "open");
        }
    }

    toggleWidgetCallback(widgetStatus) {
        const isOpen = widgetStatus == "open" ? true : false;
        this.widgetOpen = isOpen;

        this.toggleAttribute("open", isOpen);
        this.clearNotifications();
    }

    showNotifcationIcon(count) {
        if (count > 0) {
            this.notificationIcon.textContent = count;
        }
    }

    clearNotifications() {
        this.notificationIcon.textContent = "";
    }

    isUserFirstVisit() {
        return localStorage.getItem("zendesk_user_visited") == null;
    }

    initialise() {
        if (this.isUserFirstVisit()) {
            localStorage.setItem("zendesk_user_visited", "true");

            if (this.hideOnLanding) {
                this.remove();
            }
        }

        this.launcherButton.addEventListener("click", () =>
            this.toggleWidget(),
        );

        zE("messenger:on", "close", () => this.toggleWidgetCallback("close"));
        zE("messenger:on", "open", () => this.toggleWidgetCallback("open"));
        zE("messenger:on", "unreadMessages", (count) =>
            this.showNotifcationIcon(count),
        );
    }
}

if (!customElements.get("zendesk-launcher")) {
    customElements.define("zendesk-launcher", ZendeskLauncher);
}
